import { render } from "./customSidebar.vue?vue&type=template&id=0dc994de&scoped=true"
import script from "./customSidebar.vue?vue&type=script&lang=js"
export * from "./customSidebar.vue?vue&type=script&lang=js"

import "./customSidebar.vue?vue&type=style&index=0&id=0dc994de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc994de"]])

export default __exports__